import React, { useEffect, useState } from "react";
import { showSnackbar } from "../../../comopnents/snackbar";
import {
  getBlogs,
  createBlog,
  deleteBlog,
  updateBlog,
} from "../../../services/apiService";

const initialForm = {
  blogtitle: "",
  shortdesc: "",
  fulldesc: "",
  imgurl: "",
  active: "0",
};

const Blogsdata = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState(initialForm);
  const [saving, setSaving] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await getBlogs();
      setData(Array.isArray(response) ? response : response?.data || []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const openAddModal = () => {
    setEditingId(null);
    setForm(initialForm);
    setShowModal(true);
  };

  const openEditModal = (item) => {
    setEditingId(item.id || item.sno);
    const isActive =
      item.active === true ||
      item.active === "1" ||
      item.active === 1 ||
      item.active === "true";
    setForm({
      blogtitle: item.blogtitle || "",
      shortdesc: item.shortdesc || "",
      fulldesc: item.fulldesc || "",
      imgurl: item.imgurl || "",
      active: isActive ? "1" : "0",
    });
    setShowModal(true);
  };

  const getErrorMessage = (error) => {
    if (!error) return "Something went wrong. Please try again.";
    const status = error?.response?.status;
    const data = error?.response?.data;
    if (status === 400) return data?.detail || data?.message || "Invalid input. Please check the form fields.";
    if (status === 401) return "Unauthorized. Please log in again.";
    if (status === 404) return "Blog not found. It may have been deleted.";
    if (status === 500) return "Server error. Please try again later.";
    return data?.detail || data?.message || error?.message || "Something went wrong. Please try again.";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (saving) return;

    if (!form.blogtitle?.trim()) {
      showSnackbar("error", "Blog title is required.");
      return;
    }

    setSaving(true);
    const payload = {
      blogtitle: form.blogtitle.trim(),
      shortdesc: form.shortdesc.trim(),
      fulldesc: form.fulldesc.trim(),
      imgurl: form.imgurl.trim(),
      created_by: localStorage.getItem("userId") || "0",
      created_date: new Date().toISOString().split("T")[0],
      active: form.active === "1",
    };

    try {
      if (editingId) {
        await updateBlog(editingId, payload);
        showSnackbar("success", "Blog updated successfully.");
      } else {
        await createBlog(payload);
        showSnackbar("success", "Blog created successfully.");
      }
      setShowModal(false);
      await fetchData();
    } catch (error) {
      const message = getErrorMessage(error);
      showSnackbar("error", message);
      console.error("Blog save error:", error);
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this blog?")) return;
    try {
      await deleteBlog(id);
      fetchData();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.header}>
        <h3 style={styles.title}>Blogs</h3>
        <button style={styles.addBtn} onClick={openAddModal}>
          + Add Blog
        </button>
      </div>

      <div style={styles.tableContainer}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>#</th>
              <th style={styles.th}>Title</th>
              <th style={styles.th}>Short Desc</th>
              <th style={styles.th}>Image</th>
              <th style={styles.th}>Status</th>
              <th style={styles.th}>Date</th>
              <th style={styles.th}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={7} style={styles.noData}>
                  Loading...
                </td>
              </tr>
            ) : data.length > 0 ? (
              data.map((item, index) => (
                <tr key={item.id || index}>
                  <td style={styles.td}>{index + 1}</td>
                  <td style={styles.td}>{item.blogtitle}</td>
                  <td style={styles.td}>{item.shortdesc}</td>
                  <td style={styles.td}>
                    {item.imgurl ? (
                      <img
                        src={item.imgurl}
                        alt="blog"
                        style={styles.thumb}
                      />
                    ) : (
                      "-"
                    )}
                  </td>
                  <td style={styles.td}>
                    <span
                      style={{
                        ...styles.statusBadge,
                        background:
                          item.active === true
                            ? "#28a745"
                            : "#dc3545",
                      }}
                    >
                      {item.active === true
                        ? "Active"
                        : "Inactive"}
                    </span>
                  </td>
                  <td style={styles.td}>{item.created_date}</td>
                  <td style={styles.td}>
                    <div style={styles.actionBtns}>
                      <button
                        style={styles.editBtn}
                        onClick={() => openEditModal(item)}
                      >
                        Edit
                      </button>
                      <button
                        style={styles.deleteBtn}
                        onClick={() => handleDelete(item.id || item.sno)}
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={7} style={styles.noData}>
                  No blogs found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {showModal && (
        <div style={styles.overlay} onClick={() => setShowModal(false)}>
          <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
            <div style={styles.modalHeader}>
              <h4 style={{ margin: 0 }}>
                {editingId ? "Edit Blog" : "Add Blog"}
              </h4>
              <button
                style={styles.closeBtn}
                onClick={() => setShowModal(false)}
              >
                x
              </button>
            </div>
            <form onSubmit={handleSubmit} style={styles.modalBody}>
              <div style={styles.field}>
                <label style={styles.label}>
                  Blog Title <span style={styles.required}>*</span>
                </label>
                <input
                  name="blogtitle"
                  value={form.blogtitle}
                  onChange={handleChange}
                  style={styles.input}
                  required
                />
              </div>

              <div style={styles.field}>
                <label style={styles.label}>Short Description</label>
                <textarea
                  name="shortdesc"
                  value={form.shortdesc}
                  onChange={handleChange}
                  style={styles.textarea}
                  rows={2}
                />
              </div>

              <div style={styles.field}>
                <label style={styles.label}>Full Description</label>
                <textarea
                  name="fulldesc"
                  value={form.fulldesc}
                  onChange={handleChange}
                  style={styles.textarea}
                  rows={4}
                />
              </div>

              <div style={styles.field}>
                <label style={styles.label}>Image URL</label>
                <input
                  name="imgurl"
                  value={form.imgurl}
                  onChange={handleChange}
                  style={styles.input}
                  placeholder="https://..."
                />
                {form.imgurl && (
                  <img src={form.imgurl} alt="preview" style={styles.preview} />
                )}
              </div>

              <div style={styles.field}>
                <label style={styles.label}>Status</label>
                <select
                  name="active"
                  value={form.active}
                  onChange={handleChange}
                  style={styles.input}
                >
                  <option value="0">Inactive</option>
                  <option value="1">Active</option>
                </select>
              </div>

              <div style={styles.modalFooter}>
                <button
                  type="button"
                  style={styles.cancelBtn}
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button type="submit" style={styles.saveBtn} disabled={saving}>
                  {saving
                    ? "Saving..."
                    : editingId
                      ? "Update"
                      : "Save"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Blogsdata;

const styles = {
  page: {
    padding: "14px",
    background: "#fff",
    fontFamily: "Arial, sans-serif",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "14px",
  },
  title: {
    margin: 0,
    color: "#005487",
    fontSize: "20px",
    fontWeight: "bold",
  },
  addBtn: {
    padding: "8px 18px",
    background: "#005487",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    fontWeight: 600,
    cursor: "pointer",
    fontSize: "14px",
  },
  tableContainer: {
    border: "1px solid #ddd",
    borderRadius: "6px",
    overflow: "hidden",
    background: "#fff",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  th: {
    background: "#f2f2f2",
    padding: "10px",
    fontSize: "13px",
    textAlign: "left",
    borderBottom: "1px solid #ddd",
    fontWeight: 600,
  },
  td: {
    padding: "10px",
    fontSize: "13px",
    borderBottom: "1px solid #eee",
    verticalAlign: "middle",
  },
  noData: {
    textAlign: "center",
    padding: "20px",
    fontSize: "14px",
    color: "#888",
  },
  thumb: {
    width: "50px",
    height: "50px",
    objectFit: "cover",
    borderRadius: "4px",
  },
  statusBadge: {
    display: "inline-block",
    padding: "3px 10px",
    borderRadius: "12px",
    color: "#fff",
    fontSize: "12px",
    fontWeight: 600,
  },
  actionBtns: {
    display: "flex",
    gap: "6px",
  },
  editBtn: {
    padding: "4px 12px",
    background: "#ffc107",
    color: "#333",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "12px",
    fontWeight: 600,
  },
  deleteBtn: {
    padding: "4px 12px",
    background: "#dc3545",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "12px",
    fontWeight: 600,
  },
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
  modal: {
    width: "90%",
    maxWidth: "600px",
    background: "#fff",
    borderRadius: "10px",
    overflow: "hidden",
    boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
  },
  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px 20px",
    borderBottom: "1px solid #eee",
    background: "#fafbfc",
  },
  closeBtn: {
    background: "none",
    border: "none",
    fontSize: "20px",
    cursor: "pointer",
    color: "#888",
    fontWeight: "bold",
  },
  modalBody: {
    padding: "20px",
  },
  field: {
    marginBottom: "14px",
  },
  label: {
    display: "block",
    marginBottom: "5px",
    fontWeight: 600,
    fontSize: "13px",
    color: "#333",
  },
  required: {
    color: "#dc3545",
  },
  input: {
    width: "100%",
    padding: "8px 12px",
    border: "1px solid #ddd",
    borderRadius: "6px",
    fontSize: "14px",
    outline: "none",
    boxSizing: "border-box",
  },
  textarea: {
    width: "100%",
    padding: "8px 12px",
    border: "1px solid #ddd",
    borderRadius: "6px",
    fontSize: "14px",
    outline: "none",
    resize: "vertical",
    fontFamily: "inherit",
    boxSizing: "border-box",
  },
  preview: {
    width: "80px",
    height: "80px",
    objectFit: "cover",
    borderRadius: "4px",
    marginTop: "8px",
    border: "1px solid #eee",
  },
  modalFooter: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    marginTop: "20px",
    paddingTop: "16px",
    borderTop: "1px solid #eee",
  },
  cancelBtn: {
    padding: "8px 20px",
    background: "#6c757d",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "14px",
  },
  saveBtn: {
    padding: "8px 20px",
    background: "#005487",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: 600,
    fontSize: "14px",
  },
};
